<app-user-lookup (onUserFound)="onUserFound($event)" [alsdeUser]="jsonData.person"></app-user-lookup>